// The club's consent records as a CSV file. Headers and values aren't
// translated: this is a record to keep, read alongside the API's field names.

const COLUMNS = [
  "recorded_at",
  "team",
  "athlete",
  "given_by",
  "given_by_email",
  "choice",
  "agreed",
  "wording_version",
  "wording",
  "record_id",
];

const cell = (value) => {
  const text = value === null || value === undefined ? "" : String(value);
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export function consentRecordsCsv(records) {
  const rows = records.map((r) => [
    r.recorded_at,
    r.team_name,
    r.athlete_name,
    r.given_by_name,
    r.given_by_email,
    r.purpose,
    r.granted ? "yes" : "no",
    r.wording_version,
    r.wording,
    r.id,
  ]);
  return [COLUMNS, ...rows].map((row) => row.map(cell).join(",")).join("\r\n");
}

export function consentRecordsFilename(workspaceName, date = new Date()) {
  const slug = (workspaceName || "club")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  return `${slug}-consent-records-${date.toISOString().slice(0, 10)}.csv`;
}
